import React from 'react';

const RobotPenyapuJalan: React.FC = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Dengan semakin pesatnya urbanisasi, masalah sampah di kawasan perkotaan menjadi semakin kompleks. Salah satu solusi inovatif yang kini mulai banyak diterapkan adalah penggunaan robot penyapu jalan. Teknologi ini bertujuan untuk meningkatkan efisiensi pengelolaan sampah jalanan dengan mengurangi ketergantungan pada tenaga manusia dan mengoptimalkan proses pembersihan jalan.
      </p>

      <h2 className="text-2xl font-bold mb-4">Inovasi Teknologi dalam Pengelolaan Sampah</h2>
      <p className="mb-4">
        Robot penyapu jalan modern telah dilengkapi dengan berbagai teknologi canggih yang memungkinkan mereka bekerja secara otonom dan efisien. Beberapa fitur utama yang ada pada robot penyapu jalan meliputi:
      </p>
      <ul className="list-disc pl-6 mb-6">
        <li><b>Kecerdasan Buatan (AI)</b> untuk mendeteksi dan memisahkan jenis sampah di jalan</li>
        <li><b>Sistem Navigasi Otonom</b> yang memungkinkan robot beroperasi secara mandiri di jalanan yang ramai</li>
        <li><b>Penggerak Hybrid</b> yang mengkombinasikan energi listrik dan tenaga surya untuk meningkatkan efisiensi energi</li>
      </ul>

      <h2 className="text-2xl font-bold mb-4">Fitur dan Keunggulan Teknologi</h2>
      <h3 className="text-lg font-semibold mb-2">1. Sistem Penyedotan Cerdas</h3>
      <p className="mb-3">
        Robot ini menggunakan teknologi penyedotan canggih yang mampu menangani berbagai jenis sampah hingga bobot tertentu, dengan tingkat kebisingan yang sangat rendah, sehingga tidak mengganggu kenyamanan publik selama proses pembersihan berlangsung.
      </p>

      <h3 className="text-lg font-semibold mb-2">2. Pemilahan Sampah Otomatis</h3>
      <p className="mb-3">
        Dengan menggunakan AI, robot ini dapat secara otomatis memisahkan sampah berdasarkan kategori seperti sampah organik, plastik, dan sampah berbahaya. Teknologi ini membantu meningkatkan akurasi pemilahan dibandingkan dengan metode manual, yang sangat bergantung pada ketelitian manusia.
      </p>

      <h3 className="text-lg font-semibold mb-2">3. Operasional Non-Stop</h3>
      <p className="mb-4">
        Robot penyapu jalan ini dilengkapi dengan baterai berkapasitas tinggi yang memungkinkan mereka untuk beroperasi tanpa henti selama beberapa jam, dengan pengisian yang cepat dan efisien. Ini membuat mereka mampu bekerja dalam berbagai kondisi cuaca dan waktu, baik di siang maupun malam hari.
      </p>

      <h2 className="text-2xl font-bold mb-4">Dampak Positif</h2>
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <div>
          <h3 className="font-semibold mb-2">📈 Efisiensi Operasional</h3>
          <ul className="list-disc pl-6">
            <li>Pengurangan waktu pembersihan jalan secara signifikan</li>
            <li>Pengurangan biaya operasional dalam jangka panjang</li>
            <li>Peningkatan tingkat kebersihan jalan yang lebih konsisten</li>
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-2">👷 Dampak Sosial</h3>
          <ul className="list-disc pl-6">
            <li>Transformasi peran tenaga kebersihan menjadi teknisi dan pengawas</li>
            <li>Peningkatan kualitas hidup pekerja dengan penghasilan yang lebih baik</li>
            <li>Menumbuhkan minat generasi muda untuk bekerja di sektor kebersihan yang lebih modern</li>
          </ul>
        </div>
      </div>

      <h2 className="text-2xl font-bold mb-4">Tantangan dan Solusi</h2>
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
        <h3 className="font-semibold mb-2">⚠️ Tantangan yang Dihadapi</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Kerusakan akibat vandalisme pada beberapa unit robot</li>
          <li>Tantangan dalam navigasi pada jalanan sempit dan padat</li>
          <li>Keterbatasan pada beberapa komponen teknologi yang masih bergantung pada impor</li>
        </ul>
      </div>

      <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-6">
        <h3 className="font-semibold mb-2">✅ Solusi yang Diterapkan</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Kerja sama dengan pihak keamanan untuk perlindungan robot</li>
          <li>Pengembangan model mini untuk area yang lebih sempit</li>
          <li>Pengembangan komponen lokal untuk mengurangi ketergantungan impor</li>
        </ul>
      </div>

      <h2 className="text-2xl font-bold mb-4">Rencana Pengembangan di Masa Depan</h2>
      <p className="mb-4">
        Rencana untuk 5 tahun ke depan meliputi beberapa inisiatif inovatif:
      </p>
      <ul className="list-disc pl-6 mb-6">
        <li>Integrasi robot penyapu dengan sistem Smart City untuk monitoring real-time</li>
        <li>Pengembangan robot untuk menangani sampah di area yang lebih sulit dijangkau, seperti sungai dan saluran air</li>
        <li>Produksi komponen secara lokal untuk meningkatkan kemandirian teknologi</li>
      </ul>

      <p className="mb-6">
        Menurut para ahli kebijakan perkotaan, perubahan paradigma dalam pengelolaan sampah ini bukan hanya soal teknologi, tetapi juga tentang menciptakan solusi yang lebih efisien dan berkelanjutan bagi kota-kota di seluruh dunia.
      </p>
    </div>
  );
};

export default RobotPenyapuJalan;
